export const RIDER_AVAILABILITY = {
  AVAILABLE: 'true',
  UNAVAILABLE: 'false',
};
